import { useState } from "react";

import Sidebar from "./Sidebar";
import { useAuth } from "../../context/AuthContext";

export default function Layout({ children }) {
  const { user, isLoading, accessMessage, accessDetail } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const closeSidebar = () => setIsSidebarOpen(false);

  const renderShell = (content) => (
    <div className={`layout${isSidebarOpen ? " sidebar-open" : ""}`}>
      <button
        type="button"
        className="sidebar-drawer-toggle"
        onClick={() => setIsSidebarOpen((isOpen) => !isOpen)}
        aria-label={isSidebarOpen ? "Close navigation" : "Open navigation"}
        aria-expanded={isSidebarOpen}
      >
        <span aria-hidden="true" className="sidebar-drawer-toggle__icon">
          <span />
          <span />
          <span />
        </span>
      </button>
      <button
        type="button"
        className="sidebar-backdrop"
        onClick={closeSidebar}
        aria-label="Close navigation"
      />
      <Sidebar onNavigate={closeSidebar} />
      <div className="main-content">{content}</div>
    </div>
  );

  if (isLoading) {
    return renderShell(
      <section
        style={{
          minHeight: "60vh",
          display: "grid",
          placeItems: "center",
          textAlign: "center",
          padding: 24,
        }}
      >
        <div>
          <h2 style={{ marginBottom: 8 }}>Checking access...</h2>
          <p style={{ margin: 0, color: "#64748b" }}>
            Verifying your account permissions.
          </p>
        </div>
      </section>
    );
  }

  if (!user) {
    return renderShell(
      <section
        style={{
          minHeight: "60vh",
          display: "grid",
          placeItems: "center",
          textAlign: "center",
          padding: 24,
        }}
      >
        <div style={{ maxWidth: 420 }}>
          <h2 style={{ marginBottom: 8 }}>
            {accessDetail || "Sign in to continue"}
          </h2>
          <p style={{ margin: 0, color: "#64748b" }}>
            {accessMessage
              ? accessMessage
              : "Use your approved email and password to access this system."}
          </p>
        </div>
      </section>
    );
  }

  return renderShell(children);
}
